module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/16f627d1f14d4aa71e39811cf3d6e983.png";